const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRssWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 291.319 291.319",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M145.659,0c80.44,0,145.66,65.219,145.66,145.66c0,80.45-65.219,145.659-145.66,145.659 S0,226.109,0,145.66C0,65.219,65.21,0,145.659,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4a4a4a"
    },
    d: "M109.254,163.831c-10.06,0-18.226,8.157-18.226,18.226s8.157,18.226,18.226,18.226 s18.226-8.157,18.226-18.226S119.322,163.831,109.254,163.831z M103.873,118.367c-7.074,0-12.8,5.726-12.8,12.8 c0,7.064,5.726,12.8,12.8,12.8c23.997,0,43.525,19.527,43.525,43.525c0,7.064,5.726,12.8,12.809,12.8c7.055,0,12.8-5.735,12.8-12.8 C173.007,149.374,141.991,118.367,103.873,118.367z M104.119,72.839c-7.228,0-13.091,5.863-13.091,13.091 s5.863,13.091,13.091,13.091c48.623,0,88.188,39.556,88.188,88.179c0,7.228,5.854,13.091,13.091,13.091s13.091-5.872,13.091-13.091 C218.48,124.138,167.172,72.839,104.119,72.839z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRssWhite);
export default __webpack_public_path__ + "static/media/rss_white.ba0f77a74d42a4567c19cb17f86c9ee2.svg";
export { ForwardRef as ReactComponent };